import React from "react";
import { useCancelBuildMutation } from "src/ui/containers/dashboard/products/api";
import { DangerOutlinedButton } from "src/ui/shared/CustomButton";
import { MinimalTableCell } from "src/ui/shared/table/MinimalTableComponents";
import { showSuccessToast } from "src/ui/shared/toasts/Toasts";
import { makeStyles } from "tss-react/mui";

import { LogStreamer } from "@dashboard/products/components/LogStreamer/LogStreamer";
import { HoverRow } from "@shared/table/HoverRow";
import { flexRender, Row } from "@tanstack/react-table";

import { State } from "./AdminBuildsPage";

type TableItemProps = {
    setState: (value: React.SetStateAction<State>) => void;
    row: Row<API.AdminBuild>;
};

const useStyles = makeStyles()((theme) => ({
    actionCell: { display: "flex", gap: theme.spacing(1), justifyContent: "flex-end" },
}));

const TableItem: React.FC<TableItemProps> = ({ row, setState }) => {
    const [isCanceling, setIsCanceling] = React.useState(false);
    const { classes } = useStyles();
    const [cancelBuild] = useCancelBuildMutation();

    const handleCancel = async () => {
        setIsCanceling(true);
        const result = await cancelBuild(row.original.buildId);
        if (!("error" in result)) {
            showSuccessToast("Build canceled successfully");
            setState((prevState) => ({
                ...prevState,
                data: prevState.data.filter((item) => item.buildId !== row.original.buildId),
            }));
        }
        setIsCanceling(false);
    };

    return (
        <React.Fragment>
            <HoverRow clickable={false}>
                {row
                    .getVisibleCells()
                    .map((cell) => flexRender(cell.column.columnDef.cell, { ...cell.getContext(), key: cell.id }))}
                <MinimalTableCell>
                    <div className={classes.actionCell}>
                        <LogStreamer buildId={row.original.buildId} hasLogs={row.original.hasLogs} />
                        <DangerOutlinedButton onClick={handleCancel} disabled={isCanceling} loading={isCanceling}>
                            <i className="fa-solid fa-ban" />
                        </DangerOutlinedButton>
                    </div>
                </MinimalTableCell>
            </HoverRow>
        </React.Fragment>
    );
};

export default TableItem;
